module.exports = __webpack_public_path__ + "img/ssc.c8e94e43.png";